export interface Character {
  id: string;
  name: string;
  alias: string;
  role: string;
  faction: string;
  desc: string;
  tags: string[];
  relationNote: string;
  image: string;
  highlight: string;
}

export const characters: Character[] = [
  {
    id: 'li-changshou',
    name: '李长寿',
    alias: '李苟圣 · 长庚道人',
    role: '男主 · 度仙门炼气士',
    faction: '度仙门',
    desc: '本为现代人，身患绝症后重生至封神大战前的上古洪荒，成为度仙门炼气士。以「稳健」为核心生存法则，藏底牌、练遁术、算无遗策，凡事谋而后动。表面低调，实则深藏不露，被观众戏称为「李苟圣」。',
    tags: ['稳健', '深藏不露', '护短', '道心坚定'],
    relationNote: '与师妹蓝灵娥亦师亦友、相濡以沫，是众多同门情谊与CP线的中心人物。',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20portrait%20of%20a%20calm%20young%20male%20cultivator%20with%20steady%20eyes%2C%20dark%20grey-blue%20flowing%20robe%2C%20simple%20hair%20bun%2C%20holding%20a%20scroll%2C%20cinnabar%20red%20and%20ink%20tones%20on%20warm%20paper%20background%2C%20elegant%20wuxia%20cultivation%20aesthetic%2C%20soft%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=800&seq=char-lcs&orientation=squarish',
    highlight: '「隐藏底牌，是为了让在意的人都安然无恙。」',
  },
  {
    id: 'lan-linge',
    name: '蓝灵娥',
    alias: '小师妹 · 灵娥',
    role: '女主 · 李长寿师妹',
    faction: '度仙门',
    desc: '人族权贵世家出身的小师妹，入门后由李长寿一手教导十年，已能御空飞行，跻身化神二阶。性格温和坚定，对师兄既敬又爱，情愫暗生、终成道侣，育有一女李灵儿，是师门情谊线里最暖的存在。',
    tags: ['温柔', '努力', '敬慕', '御空飞行'],
    relationNote: '与李长寿从师生到道侣，是「兄妹CP」最核心的糖点来源。',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20portrait%20of%20a%20gentle%20young%20woman%20disciple%20with%20long%20flowing%20hair%2C%20white%20and%20pale%20robe%2C%20soft%20warm%20smile%2C%20cinnabar%20red%20and%20ink%20tones%20on%20warm%20paper%20background%2C%20elegant%20wuxia%20cultivation%20aesthetic%2C%20soft%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=800&seq=char-lle&orientation=squarish',
    highlight: '「师兄教我的每句话，我都好好记着。」',
  },
  {
    id: 'jiu-jiu',
    name: '酒玖',
    alias: '酒玖师叔 · 小玖儿',
    role: '师叔 · 忘情上人九弟子',
    faction: '破天峰',
    desc: '破天峰忘情上人座下九弟子，是李长寿名义上的「师叔」。又飒又沙雕，嗜酒成痴，看似不羁实则重情。与李长寿的互动妙趣横生，是高甜名场面与「叔侄向」CP的重要人物。',
    tags: ['爱喝酒', '又飒又沙雕', '重情', '亦正亦邪'],
    relationNote: '名义上的长辈，实际互动充满反差萌，贡献大量搞笑与暧昧瞬间。',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20portrait%20of%20an%20elegant%20confident%20woman%20cultivator%20holding%20a%20wine%20gourd%2C%20playful%20expression%2C%20grey-purple%20flowing%20robe%2C%20cinnabar%20red%20and%20ink%20tones%20on%20warm%20paper%20background%2C%20elegant%20wuxia%20cultivation%20aesthetic%2C%20soft%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=800&seq=char-jj&orientation=squarish',
    highlight: '「小长寿，来陪师叔喝一杯？」',
  },
  {
    id: 'ao-yi',
    name: '敖乙',
    alias: '敖乙 · 剑心通明',
    role: '东海龙族 · 剑修',
    faction: '东海龙宫',
    desc: '东海龙宫出身的天骄剑修，「鲸饮未吞海，剑气已横秋」。性情傲然冷冽，剑道通明，与李长寿在历练中相识相交，是「江湖知己」向关系线的代表角色。',
    tags: ['剑修', '傲然', '天骄', '知己'],
    relationNote: '与李长寿从萍水相逢到并肩同行，剑意相通的惺惺相惜。',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20portrait%20of%20a%20cool%20young%20woman%20swordswoman%20with%20a%20long%20sword%2C%20flowing%20hair%2C%20pale%20teal%20robe%2C%20dragon%20princess%20aura%2C%20cinnabar%20red%20and%20ink%20tones%20on%20warm%20paper%20background%2C%20elegant%20wuxia%20cultivation%20aesthetic%2C%20soft%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=800&seq=char-ay&orientation=squarish',
    highlight: '「鲸饮未吞海，剑气已横秋。」',
  },
  {
    id: 'youqin-xuanya',
    name: '有琴玄雅',
    alias: '玄雅 · 琴心',
    role: '破天峰大师姐',
    faction: '破天峰',
    desc: '破天峰大师姐，通音律、掌琴心，清冷疏离却暗藏温柔。与酒玖同门，与李长寿、蓝灵娥亦有交集，是人物关系图谱中承上启下的关键一环。',
    tags: ['琴心', '清冷', '大师姐', '腹有乾坤'],
    relationNote: '同门姊妹情谊的轴心人物，牵动多条关系线。',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20portrait%20of%20a%20refined%20woman%20holding%20a%20guqin%2C%20poised%20and%20graceful%2C%20teal-green%20robe%2C%20calm%20distant%20expression%2C%20cinnabar%20red%20and%20ink%20tones%20on%20warm%20paper%20background%2C%20elegant%20wuxia%20cultivation%20aesthetic%2C%20soft%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=800&seq=char-yqxy&orientation=squarish',
    highlight: '「琴音起处，恩怨自知。」',
  },
  {
    id: 'qi-yuan',
    name: '齐源',
    alias: '齐源长老',
    role: '师父 · 度仙门长老',
    faction: '度仙门',
    desc: '度仙门长老，李长寿与蓝灵娥共同的师父。看似古板实则护短，对徒弟倾注心血。师徒情谊是师门日常中最温情的底色。',
    tags: ['护短', '古板', '师恩', '慈严'],
    relationNote: '李长寿与蓝灵娥的师门纽带，是「师徒」关系线的核心。',
    image: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink-wash%20painting%20portrait%20of%20a%20wise%20old%20daoist%20master%20with%20white%20beard%20in%20flowing%20robes%2C%20kind%20eyes%2C%20cinnabar%20red%20and%20ink%20tones%20on%20warm%20paper%20background%2C%20elegant%20wuxia%20cultivation%20aesthetic%2C%20soft%20lighting%2C%20high%20detail%2C%20no%20text&width=800&height=800&seq=char-qy&orientation=squarish',
    highlight: '「师父这辈子，就盼着你们平安。」',
  },
];